import React, { Component, Fragment } from 'react';
import Breadcrumb from '../../../components/organism/Breadcrumb';

class GP2AfficheResultats extends Component {

    constructor(props) {
        super(props);

        const { serial, latest, all, request  } = props.location.state;

        this.state = {
            serial,
            files: all || [],
            selectedFile: latest,
            request: request,
            errors: [],
        };
    }

    selectFile = (file) => {
        this.setState({
            selectedFile: file,
        });
    };

    renderFileHeader = () => {

        const { selectedFile } = this.state;

        if (!selectedFile) {
            return (
                <div className="gp2-empty">
                    <p>Aucun fichier sélectionné.</p>
                </div>
            );
        }

        return (
            <div className="gp2-file-header">

                <div className="gp2-file-title">
                    <div className="gp2-file-icon">
                        {selectedFile.extension}
                    </div>

                    <div>
                        <h2>{selectedFile.filename}</h2>
                        <span>{selectedFile.from_label}</span>
                    </div>
                </div>

                <div className="gp2-file-infos">

                    <div className="gp2-file-info">
                        <span>Date</span>
                        <strong>{selectedFile.date}</strong>
                    </div>

                    <div className="gp2-file-info">
                        <span>Extension</span>
                        <strong>{selectedFile.extension}</strong>
                    </div>

                    <div className="gp2-file-info">
                        <span>Source</span>
                        <strong>{selectedFile.from_label}</strong>
                    </div>

                </div>

            </div>
        );
    };

    renderTRT = () => {

        const { selectedFile } = this.state;
        const decode = selectedFile && selectedFile.decode;

        if (!decode || !decode.values) {
            return (
                <div className="gp2-empty">
                    <p>Aucune donnée TRT décodée.</p>
                </div>
            );
        }

        return (
            <div className="gp2-trt">

                {decode.values.map((item, index) => (

                    <div key={index} className="gp2-decoding-card">

                        <div className="gp2-decoding-card__header">
                            <h3>{item.type}</h3>
                        </div>

                        <table className="table">
                            <tbody>
                                {Object.entries(item.records || {}).map(
                                    ([key, value]) => (
                                        <tr key={key}>
                                            <td>
                                                <strong>{key}</strong>
                                            </td>
                                            <td>
                                                {String(value)}
                                            </td>
                                        </tr>
                                    )
                                )}
                            </tbody>
                        </table>

                    </div>

                ))}

            </div>
        );
    };

    renderGP2 = () => {

        const { selectedFile } = this.state;
        const decode = selectedFile && selectedFile.decode;

        if (!decode || !decode.length) {
            return (
                <div className="gp2-empty">
                    <p>Aucune donnée GP2 décodée.</p>
                </div>
            );
        }

        return (
            <div className="gp2-gp2">

                {decode.map((equipement, index) => (

                    <div
                        key={index}
                        className="gp2-equipment"
                    >

                        <div className="gp2-equipment__header">

                            <div>
                                <span>MAN</span>
                                <strong>{equipement.man}</strong>
                            </div>

                            <div>
                                <span>Adresse</span>
                                <strong>{equipement.address}</strong>

                                <span className="gp2-equipment__date">
                                    {equipement.date_releve}
                                </span>
                            </div>
                        </div>

                        <div className="gp2-equipment__values">

                            {equipement.values.map((value, valueIndex) => (

                                <div
                                    key={valueIndex}
                                    className="gp2-value"
                                >
                                    <span className="gp2-value__position">
                                        V{value.pos}
                                    </span>

                                    <strong>
                                        {value.value}
                                    </strong>

                                    <span>
                                        {value.unit}
                                    </span>
                                </div>

                            ))}

                        </div>

                    </div>

                ))}

            </div>
        );
    };

    renderDecode = () => {

        const { selectedFile } = this.state;

        if (!selectedFile) {
            return null;
        }

        return (
            <Fragment>

                <div className="gp2-section-title">
                    <h2>Données décodées</h2>

                    <span className="gp2-badge">
                        {selectedFile.extension}
                    </span>
                </div>

                {selectedFile.extension === 'TRT'
                    ? this.renderTRT()
                    : this.renderGP2()
                }

            </Fragment>
        );
    };

    renderSidebar = () => {

        const { files, selectedFile } = this.state;

        return (
            <aside className="gp2-sidebar">

                <div className="gp2-sidebar__header">
                    <h2>Fichiers</h2>
                    <span>{files.length}</span>
                </div>

                <div className="gp2-file-list">

                    {files.map((file, index) => {

                        const isSelected =
                            selectedFile &&
                            selectedFile.filename === file.filename;

                        return (
                            <button
                                key={index}
                                type="button"
                                className={
                                    `gp2-file-item ${
                                        isSelected
                                            ? 'gp2-file-item--active'
                                            : ''
                                    }`
                                }
                                onClick={() => this.selectFile(file)}
                            >

                                <div className="gp2-file-item__icon">
                                    {file.extension}
                                </div>

                                <div className="gp2-file-item__content">

                                    <span>
                                        {file.date}
                                    </span>

                                    <strong>
                                        {file.filename}
                                    </strong>

                                    <span>
                                        {file.from_label}
                                    </span>

                                </div>

                            </button>
                        );
                    })}

                </div>

            </aside>
        );
    };

    render() {

        const { serial, selectedFile, request } = this.state;

        return (
            <Fragment>

                <Breadcrumb
                    titre="Testeur GP2"
                    ico={sessionStorage.getItem('icoMenu')}
                />

                <div className="wrapper-100">

                    {/* HEADER */}
                    <header className="gp2-header">

                        <div className="ico__xl ico--code"></div>

                        <div>
                            <h1>Testeur GP2</h1>
                            <p>Centrale {serial}</p>
                            {request && (
                                <small className="gp2-history-limit">
                                    Recherche : {request.nbdays} jours · limite : {request.max_files} fichiers
                                </small>
                            )}
                        </div>

                    </header>


                    {/* APPLICATION */}
                    <div className="gp2-layout">

                        {/* SIDEBAR */}
                        {this.renderSidebar()}


                        {/* CONTENU */}
                        <main className="gp2-content">

                            {!selectedFile ? (

                                <div className="gp2-empty">
                                    <h2>Aucun fichier</h2>
                                    <p>
                                        Sélectionnez un fichier dans la
                                        navigation.
                                    </p>
                                </div>

                            ) : (

                                <Fragment>

                                    {this.renderFileHeader()}

                                    <div className="gp2-content__body">
                                        {this.renderDecode()}
                                    </div>

                                </Fragment>

                            )}

                        </main>

                    </div>

                </div>

            </Fragment>
        );
    }
}

export default GP2AfficheResultats;